import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** Interactive terminal system — a console with a live typing cursor. */
const TerminalThumb: React.FC = () => (
  <ThumbFrame label="Interactive Terminal System">
    {/* Terminal window */}
    <rect x="50" y="58" width="300" height="184" rx="12" fill="#ffffff" stroke={INK} strokeWidth="1.8" />

    {/* Title bar */}
    <circle cx="70" cy="78" r="4" fill={INK} opacity="0.25" />
    <circle cx="84" cy="78" r="4" fill={INK} opacity="0.25" />
    <circle cx="98" cy="78" r="4" fill={INK} opacity="0.25" />
    <text x="200" y="82" textAnchor="middle" fontFamily="'JetBrains Mono', monospace" fontSize="10" fill={INK} opacity="0.4">bash</text>
    <line x1="50" y1="94" x2="350" y2="94" stroke={INK} strokeWidth="1" opacity="0.1" />

    {/* Prompt line 1 */}
    <text x="70" y="122" fontFamily="'JetBrains Mono', monospace" fontSize="13" fill={INK}>$</text>
    <rect x="84" y="114" width="150" height="8" rx="4" fill={INK} opacity="0.7" />

    {/* Output lines */}
    <rect x="70" y="138" width="200" height="7" rx="3.5" fill={INK} opacity="0.13" />
    <rect x="70" y="152" width="164" height="7" rx="3.5" fill={INK} opacity="0.13" />
    <rect x="70" y="166" width="210" height="7" rx="3.5" fill={INK} opacity="0.13" />

    {/* Prompt line 2 with typed command + blinking cursor */}
    <text x="70" y="200" fontFamily="'JetBrains Mono', monospace" fontSize="13" fill={INK}>$</text>
    <rect x="84" y="192" width="96" height="8" rx="4" fill={INK} opacity="0.7" />
    <rect x="186" y="190" width="9" height="13" fill={INK}>
      <animate attributeName="opacity" values="1;1;0;0" dur="1s" repeatCount="indefinite" />
    </rect>
  </ThumbFrame>
);

export default TerminalThumb;
